// extracted by css-extract-rspack-plugin
export default {"q_view_wrapper":"u7hC5_PVg6MVGii2","s_header":"VKwkk0DlQ_0Gnl1j","s_title":"fzOhpZl78LYZWgli","q_view_table":"TlcBMYurPZIEgsdB","btn_end":"onLFIbZVQ8_U25Nc"};